module.exports = __webpack_public_path__ + "static/media/1.3e9dd7b9.png";